import React, { useEffect, useState } from "react";
import { SmokingsContainer } from "../styles";
import { BackToTop, Footer, NavItem, NavMenu, ToggleButton } from "../../Inicio/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { ModelCard, ModelGrid, ModelImage, ModelInfo, ModelName } from "../../Trajes/Negros/styles";

const Snegros = () => {
    const [collapsed, setCollapsed] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if(window.scrollY > 300) {
                setShowButton(true)
            } else {
                setShowButton(false)
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    };

    useEffect(() => {
                if(collapsed) {
                    document.body.style.overflow = "hidden";
                } else {
                    document.body.style.overflow = "auto";
                }
        
                return () => {
                    document.body.style.overflow = "auto";
                };
            }, [collapsed])
    

    return (
        <>
            <SmokingsContainer>
                <p>Smokings negros</p>
                <ToggleButton collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
                    {collapsed ? "✕" : "☰"}
                </ToggleButton>
                <NavMenu collapsed={collapsed}>\

                    <NavItem onClick={() => navigate("/")}>
                        Inicio
                    </NavItem>

                    <NavItem onClick={() => navigate("/trajes")}>
                        Trajes
                    </NavItem>

                    <NavItem 
                        onClick={() => navigate("/smokings")}
                        active = {location.pathname.startsWith("/smokings")}    
                    >
                        Smokings
                    </NavItem>

                    <NavItem onClick={() => navigate("/togas")}>
                        Togas
                    </NavItem>
                    <NavItem>
                        <a
                            href="/catalogo-trajes"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Catálogo
                        </a>
                    </NavItem>
                    <NavItem><a href="https://wa.me/5213311407070" target="_blank" rel="noopener noreferrer">Contacto</a></NavItem>
                </NavMenu>
            </SmokingsContainer>

            <ModelGrid>
                <ModelCard>
                    <ModelImage 
                        src="/img/Italo-smk-ligero.jpg" alt="Italo smoking"
                        onClick={() => navigate("/smokings/negros/italo-smk")}
                    />
                    <ModelInfo>
                        <ModelName>Italo smoking</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Tarento.jpg" alt="Tarento"
                        onClick={() => navigate('/smokings/negros/tarento')}
                    />
                    <ModelInfo>
                        <ModelName>Tarento</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Solapa-de-collar.jpg" alt="Solapa de collar"
                        onClick={() => navigate("/smokings/negros/collar")}
                    />
                    <ModelInfo>
                        <ModelName>Solapa de collar</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Manhattan.jpg" alt="Manhattan"
                        onClick={() => navigate("/smokings/negros/manhattan")}
                    />
                    <ModelInfo>
                        <ModelName>Manhattan</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Munich.jpg" alt="Munich"
                        onClick={() => navigate("/smokings/negros/munich")}
                    />
                    <ModelInfo>
                        <ModelName>Múnich</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Berlin.jpg" alt="Berlin"
                        onClick={() => navigate("/smokings/negros/berlin")}
                    />
                    <ModelInfo>
                        <ModelName>Berlín</ModelName>
                    </ModelInfo>
                </ModelCard>
            </ModelGrid>
            <Footer>
                <p>Eleganza Sartoriale</p>
                <p>Guadalajara, Jalisco</p>
                <div>
                    <a href="https://www.instagram.com/renta_de_trajes_mr?utm_source=qr&igsh=MW9pb2VwMnRmeW8zaw==">Intagram</a>
                    <a href="https://www.facebook.com/share/14WVJRCc3W4/">Facebook</a>
                    <a href="https://www.tiktok.com/@rentadetrajesmr?_r=1&_t=ZS-95BqJJ1lF7X">Tik Tok</a>
                </div>
                <div>
                    <p>© 2026 Renta de Trajes MR. Todos los derechos reservados.</p>
                </div>
            </Footer>
            {showButton && (
                <BackToTop onClick={scrollToTop}>
                    ▲
                </BackToTop>
            )}
        </>
    )
};

export default Snegros;